// extracted by mini-css-extract-plugin
module.exports = {"module":"needy-plate_module__Xfnk-"};